module.exports = __webpack_public_path__ + "static/media/ItProfessional.5c67b41e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/ItProfessional.svg
// module id = 1359
// module chunks = 0